import axios from "axios";

export const getRuoliApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/ruolo/`);
}

export const aggiungiRuoloApi = (ruolo) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/ruolo/`, ruolo);
}

export const rimuoviRuoloApi = (id) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/ruolo/${id}`);
}